import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product, StandardName} from "../../../../../store/state/order.state";
import {ChangeSet} from "../../../history/order-history.model";
import {TranslationsHelperService} from "../../../../translations/translations-helper.service";
import {ClientCountryBasedConfig} from "../../../../../configuration/configuration.model";

@Component({
    selector: 'employee-details',
    templateUrl: './employee-details.template.html',
    styleUrls: ['./employee-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmployeeDetailsComponent {

	@Input() product: Product;
	@Input() changeSet: ChangeSet;	// optional
	@Input() translateClientsData;
	@Input() useOriginalTranslations: boolean;
	@Input() config: ClientCountryBasedConfig;

	constructor(public translationsHelper: TranslationsHelperService) {
	}

	areShiftsChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].shifts;
	}

	areEmployeeDetailsChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			(!!this.changeSet.changes.productChanges[this.product.standard.name].partTimeOrTempEmployeesIncluded || !!this.changeSet.changes.productChanges[this.product.standard.name].employeesCountDescription);
	}

	standardName(): StandardName {
		return this.product.standard.name;
	}

	rand() {
		// added milliseconds to distinguish radio buttons in different components: UMB-5539
		return new Date().getMilliseconds()
	}

	showPartEmployee() {
		if (!this.config) return true;
		return this.config.order.showPartTimeEmployees
	}
}
